declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xxl: true;
  }
}

const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1300,
    xl: 1636,
    xxl: 1960,
  },
};

export default breakpoints;
